var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-with-navbar',{attrs:{"login":_vm.loginButton}},[_c('bb-error-page',_vm._b({staticClass:"p-l-20 p-r-20"},'bb-error-page',_vm.login,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }